import { render, staticRenderFns } from "./RecentInvoice.vue?vue&type=template&id=7f74f411"
import script from "./RecentInvoice.vue?vue&type=script&lang=js"
export * from "./RecentInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports